class VideoTranscript extends HTMLElement {
  connectedCallback() {
    const content = this.querySelector('.video-transcript__content');
    const button = this.querySelector('.video-transcript__button button');

    console.log('here', content)
    if (!content || !button) return;

    button.addEventListener('click', () => {
      content.classList.toggle('expanded');
      button.textContent = content.classList.contains('expanded') ? 'Read Less' : 'Read More';
    });
  }
}

if (!customElements.get('video-transcript')) {
  customElements.define('video-transcript', VideoTranscript);
}